import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { UwRule } from 'types/uwService';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import ProductLineTitle from 'components/common/general/ProductLineTitle';
import { toJS } from 'mobx';
import { ChevronDown, ChevronUp } from '@insurancemenu/imenu-components-lib/dist/icons';
import { Button } from '@insurancemenu/imenu-components-lib';
import clsx from 'clsx';
import { createStyles } from './styles';

const ReviewSubmitGuidelines = observer((): JSX.Element => {
  const {
    reviewSubmitStore: { uwResults, isUwRulesNotPass },
  } = useRootStore();
  const classes = createStyles();

  const [isExpanded, setIsExpanded] = useState(isUwRulesNotPass);

  const guidelines = uwResults.guidelines.map((dateObj) => toJS(dateObj)).slice();

  const rulesGuidelines = (rules: UwRule, productLineId: ProductLineId): JSX.Element[] => {
    return Object.keys(rules).map((rule) => {
      return (
        <p key={`${productLineId}_${rule}`}>
          <span className={classes.ruleName}>{rule.split('_').join(' ')}: </span>
          <span className={classes.ruleText}>{rules[rule]}</span>
        </p>
      );
    });
  };

  return (
    <div className={classes.guidelineCard}>
      <Button
        className={clsx(classes.cardHeaderName, !isExpanded && classes.collapsedSection)}
        type="text"
        rightIconProp={isExpanded ? <ChevronUp /> : <ChevronDown />}
        onClick={(): void => {
          setIsExpanded(!isExpanded);
        }}
      >
        Underwriting Guidelines
      </Button>
      {isExpanded &&
        guidelines.map((guideline) => (
          <div key={`${guideline.productLineId}_section`} className={classes.productLineRulesBlock}>
            <ProductLineTitle productLineId={guideline.productLineId} />
            <div className={classes.guidelineRulesBlock}>
              {rulesGuidelines(guideline.rules, guideline.productLineId)}
            </div>
          </div>
        ))}
    </div>
  );
});

export default ReviewSubmitGuidelines;
